export default "__VITE_ASSET__Cit3D6QO__"